import React, { useState, useEffect } from 'react';
import moment from "moment";
import { toast } from 'react-toastify';
import APIClient from '../../../helpers/APIClient';
import PageBody from '../../../components/PageBody';
import Loader from '../../../components/Loader';
import { connect } from 'react-redux';
import { baseUrl } from '../../../constants/environment';
import styled from 'styled-components';
import IconCalendarBlack from '../../../assets/images/icon/ic_calendar-black.svg';
import Flatpickr from 'react-flatpickr'
import Select from 'react-select';
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import { Button, CardBody, Col, FormGroup, InputGroupAddon, Label, Row, Table } from 'reactstrap';
import { cloneDeep } from 'lodash';
import { getDaysBetweenDates } from '../Shift';
import WeekSelect from "flatpickr/dist/plugins/weekSelect/weekSelect";
import RowEmpty from 'src/components/RowEmpty';
import noData from '../../..//assets/images/ic_row-empty.svg';

const AddSheet = (props: any) => {
    const { closeModal, action, user, onRefresh } = props
    const [data, setData] = useState<any>({
        day_from: action?.data?.day_from,
        day_to: action?.data?.day_to,
    })
    const [dataLine, setDataLine] = useState<any>([])
    const [doctor, setDoctor] = useState<any>([]);
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        loadInit()
    }, []);

    const loadInit = async () => {
        const params = {
            status: 1,
            page: 1,
            limit: 100,
        }
        const [
            responseUsertitleDoctor
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/usertitle/config`, {
                type: 'doctor'
            })
        ]);
        if (responseUsertitleDoctor.response !== undefined) {
            const usertitle_ids = responseUsertitleDoctor?.response?.usertitle_ids ? JSON.parse(responseUsertitleDoctor?.response?.usertitle_ids) : []
            fetchUserDoctor(usertitle_ids)
        }
    }

    const fetchUserDoctor = async (usertitle_ids: number[]) => {
        const url = `${baseUrl}/user`;
        const params = {
            limit: 500,
            status: 1,
            usertitle_ids: usertitle_ids || undefined
        }
        setLoading(true)
        let response: any = await APIClient.GET(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            let Arr: any = [{
                value: "",
                label: "-Bác sĩ-",
            }];
            response.response?.data?.map((e: any) => {
                Arr?.push({
                    value: e?.id,
                    label: e?.name,
                    ...e,
                })
            })
            setDoctor(Arr)
        }
    }

    useEffect(() => {
        loadData()
    }, [data?.day_from, data?.day_to]);

    const loadData = async () => {
        const formData = {
            from: data?.day_from,
            to: data?.day_to,
            branch_id: user?.branch_id?.id,
        }
        if (formData?.from && formData?.to) {
            formData.from = moment(formData?.from).startOf('day').valueOf()
            formData.to = moment(formData?.to).startOf('day').valueOf()
        }
        const url = `${baseUrl}/shift`;
        setLoading(true)
        const [
            response,
            responseClinic
        ] = await Promise.all([
            APIClient.GET(url, formData),
            APIClient.GET(`${baseUrl}/clinic`, {
                status: 1,
                page: 1,
                limit: 100,
            })
        ]);
        setLoading(false)
        let clinic: any = [];
        responseClinic.response?.data?.map((e: any) => {
            clinic?.push({
                ...e,
                value: e?.id,
                label: e?.name
            })
        })
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response?.response?.data;
            const dataShift = resData && resData[0] || {}
            const dataLine = dataShift?.detail?.reduce((prev: any, item: any) => {
                const dataClinic = clinic?.reduce((prevClinic: any, itemClinic: any) => {
                    prevClinic = [...prevClinic, {
                        "clinic": itemClinic,
                        "shift_id": dataShift?.id,
                        "shift_line_id": item?.id,
                        "clinic_id": itemClinic?.id,
                        "user_id": null,
                        "branch_id": user?.branch_id?.id
                    }]
                    return prevClinic
                }, [])
                prev = [...prev, {
                    shift_id: dataShift,
                    shift_line_id: item,
                    data: dataClinic
                }]
                return prev
            }, [])
            setDataLine(dataLine)
        }
    }

    const handleChange = (indexShift: number, indexClinic: number, value: any) => {
        const newDataLine = cloneDeep(dataLine)
        newDataLine[indexShift].data[indexClinic].user_id = value
        setDataLine(newDataLine)
    }

    const validationFrom = () => {
        if (!(data.day_from) || !(data.day_to)) {
            toast.warning('Thời gian áp dụng không được để trống!');
            return false
        }
        return true
    }

    const handleSubmit = async () => {
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/shift/sheet-by-week`;
        const dates: any = getDaysBetweenDates(moment(data.day_from), moment(data.day_to))
        const newDataLine = dataLine?.reduce((prev: any, item: any) => {
            const dataByClinic = item?.data?.reduce((prevByClinic: any, itemByClinic: any) => {
                const prevByDay = dates?.reduce((prevByDay: any, itemByDay: any) => {
                    prevByDay = [...prevByDay, {
                        "shift_id": itemByClinic?.shift_id,
                        "shift_line_id": itemByClinic?.shift_line_id,
                        "clinic_id": itemByClinic?.clinic_id,
                        "user_id": itemByClinic?.user_id,
                        "branch_id": itemByClinic?.branch_id,
                        "day": moment(itemByDay, 'DD/MM/YYYY').startOf('day').valueOf()
                    }]
                    return prevByDay
                }, [])
                prevByClinic = [...prevByClinic, ...prevByDay]
                return prevByClinic
            }, [])
            prev = [...prev, ...dataByClinic]
            return prev
        }, [])
        const params = {
            "data": newDataLine
        }
        let response: any = await APIClient.POST(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Lưu ca làm việc của phòng khám thành công')
            closeModal()
            onRefresh()
        }
    }

    console.log("dataLine", dataLine)

    return (
        <CardBody className='p-0' style={{
            width:
                dataLine?.length == 1 ? 680
                    : dataLine?.length === 2 ? 890
                        : dataLine?.length >= 3 ? 1300
                            : 680
        }}>
            <PageContent>
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-action-title">
                        Sắp xếp lịch làm việc
                    </h5>
                    <button onClick={() => closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
                </div>
                <div className="modal-body pt-2 pb-2" style={{ maxHeight: '80vh', overflow: 'auto' }}>
                    <Row>
                        {/* <Col md={4} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label><span>*</span>Thời gian áp dụng từ</Label>
                                    <Flatpickr
                                        value={[data?.day_from && new Date(moment(data?.day_from).startOf('days').valueOf())]}
                                        onChange={(date: any) => {
                                            setData({
                                                ...data,
                                                day_from: date[0] ? moment(date[0]).valueOf() : undefined,
                                            })
                                        }}
                                        options={{
                                            locale: Vietnamese,
                                            allowInput:true,
                                            dateFormat: "d/m/Y",
                                            "disable": [
                                                function(date) {
                                                    // return true to disable
                                                    return (date.getDay() !== 1);

                                                }
                                            ],
                                            // minDate: moment().add(1, 'week').startOf("isoWeek").valueOf()
                                            minDate: moment().startOf("isoWeek").valueOf()
                                        }}
                                        placeholder="dd/mm/yyyy"
                                    />
                                    <InputGroupAddon addonType="append" className='d-flex align-items-center' style={{right: 20}}>
                                            <img src={IconCalendarBlack} alt="icon" />
                                    </InputGroupAddon>
                                </FormGroup>
                            </Col>
                            <Col md={4} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label><span>*</span>Thời gian áp dụng đến</Label>
                                    <Flatpickr
                                        value={[data?.day_to && new Date(moment(data?.day_to).startOf('days').valueOf())]}
                                        onChange={(date: any) => {
                                                setData({
                                                    ...data,
                                                    day_to: date[0] ? moment(date[0]).valueOf() : undefined,
                                                })
                                        }}
                                        options={{
                                            locale: Vietnamese,
                                            allowInput:true,
                                            dateFormat: "d/m/Y",
                                            "disable": [
                                                function(date) {
                                                    // return true to disable
                                                    return (date.getDay() !== 0);

                                                }
                                            ],
                                            // minDate: moment().add(1, 'week').endOf("isoWeek").startOf('day').valueOf()
                                            minDate: moment().endOf("isoWeek").startOf('day').valueOf()
                                        }}
                                        placeholder="dd/mm/yyyy"
                                    />
                                    <InputGroupAddon addonType="append" className='d-flex align-items-center' style={{right: 20}}>
                                            <img src={IconCalendarBlack} alt="icon" />
                                    </InputGroupAddon>
                                </FormGroup>
                            </Col> */}
                        <Col md={12} xs={12}>
                            <FormGroup className='nutri-form'>
                                <Label><span>*</span>Thời gian áp dụng</Label>
                                <Flatpickr
                                    value={[new Date(moment(data?.day_from, 'YYYY-MM-DD').startOf('day').valueOf()), new Date(moment(data?.day_to, 'YYYY-MM-DD').endOf('day').valueOf())]}
                                    // onChange={(date: any) => {
                                    //         setData({
                                    //             ...data,
                                    //             day_to: date[0] ? moment(date[0]).valueOf() : undefined,
                                    //         })
                                    // }}
                                    onChange={(date: any) => {
                                        const day = moment(date[0]).endOf("day").format('YYYY-MM-DD')
                                        const from = moment(day).startOf('isoWeek')
                                        const to = moment(day).endOf('isoWeek')
                                        setData({
                                            ...data,
                                            day_from: from,
                                            day_to: to,
                                        })
                                    }}
                                    options={{
                                        locale: Vietnamese,
                                        allowInput: true,
                                        mode: "range",
                                        dateFormat: "d/m/Y",
                                        // "disable": [
                                        //     function(date) {
                                        //         // return true to disable
                                        //         return (date.getDay() !== 0);

                                        //     }
                                        // ],
                                        // minDate: moment().add(1, 'week').endOf("isoWeek").startOf('day').valueOf()
                                        minDate: moment().endOf("isoWeek").startOf('day').valueOf(),
                                        plugins: [new WeekSelect({
                                            weekStartDay: new Date(moment(data?.day_from, 'YYYY-MM-DD').startOf('day').valueOf()),
                                            weekEndDay: new Date(moment(data?.day_to, 'YYYY-MM-DD').endOf('day').valueOf()),
                                        })],
                                    }}
                                    placeholder="dd/mm/yyyy"
                                />
                                <InputGroupAddon addonType="append" className='d-flex align-items-center' style={{ right: 20 }}>
                                    <img src={IconCalendarBlack} alt="icon" />
                                </InputGroupAddon>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        {!loading && (dataLine?.length === 0 || !dataLine) &&
                            <Col md={12} className="no-data">
                                <img src={noData} alt="" className='images-nodata' />
                                <p style={{ textAlign: 'center', marginTop: 10 }}>Chưa có lịch làm việc cho khoảng thời gian này</p>
                            </Col>
                        }
                        {dataLine?.map((itemShift: any, indexShift: number) => {
                            return (
                                <Col md={
                                    dataLine?.length == 1 ? 12
                                        : dataLine?.length === 2 ? 6
                                            : dataLine?.length === 3 ? 4
                                                : 3
                                } key={`itemShift-${indexShift}`}>
                                    <div className='calendar-table shift-table' style={{ overflow: 'unset' }}>
                                        <Table className="mb-0 table-bordered" >
                                            <tbody>
                                                <tr>
                                                    <td className='text-left td-title' rowSpan={itemShift?.data?.length + 1}>
                                                        <b>{itemShift?.shift_line_id?.name}</b><br />
                                                        <p>{itemShift?.shift_line_id?.time_from} - {itemShift?.shift_line_id?.time_to}</p>
                                                    </td>
                                                </tr>
                                                {itemShift?.data?.map((itemClinic: any, numberClinic: number) => {
                                                    return (
                                                        <tr key={`itemShift-${numberClinic}`}>
                                                            <td className='text-left td-title'>{itemClinic?.clinic?.name}</td>
                                                            <td className='' style={{ minWidth: 160 }}>
                                                                <div style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',

                                                                }}>
                                                                    <Select
                                                                        className="react-select react-select-noline"
                                                                        classNamePrefix="react-select"
                                                                        placeholder="-Chọn bác sĩ-"
                                                                        options={doctor}
                                                                        onChange={(value: any) => {
                                                                            handleChange(indexShift, numberClinic, value.value)
                                                                        }}
                                                                        value={doctor?.filter((option: any) => itemClinic?.user_id === option.value)}
                                                                    ></Select>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Col>
                            )
                        })}
                        {dataLine?.map((itemShift: any, indexShift: number) => {
                            return (
                                <Col md={
                                    dataLine?.length == 1 ? 12
                                        : dataLine?.length === 2 ? 6
                                            : dataLine?.length === 3 ? 4
                                                : 3
                                } key={`itemShift-${indexShift}`}>
                                    <div className='calendar-table shift-table' style={{ overflow: 'unset' }}>
                                        <Table className="mb-0 table-bordered" >
                                            <tbody>
                                                <tr>
                                                    <td className='text-left td-title' rowSpan={itemShift?.data?.length + 1}>
                                                        <b>{itemShift?.shift_line_id?.name}</b><br />
                                                        <p>{itemShift?.shift_line_id?.time_from} - {itemShift?.shift_line_id?.time_to}</p>
                                                    </td>
                                                </tr>
                                                {itemShift?.data?.map((itemClinic: any, numberClinic: number) => {
                                                    return (
                                                        <tr key={`itemShift-${numberClinic}`}>
                                                            <td className='text-left td-title'>{itemClinic?.clinic?.name}</td>
                                                            <td className='' style={{ minWidth: 160 }}>
                                                                <div style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',

                                                                }}>
                                                                    <Select
                                                                        className="react-select react-select-noline"
                                                                        classNamePrefix="react-select"
                                                                        placeholder="-Chọn bác sĩ-"
                                                                        options={doctor}
                                                                        onChange={(value: any) => {
                                                                            handleChange(indexShift, numberClinic, value.value)
                                                                        }}
                                                                        value={doctor?.filter((option: any) => itemClinic?.user_id === option.value)}
                                                                    ></Select>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Col>
                            )
                        })}
                    </Row>
                    {dataLine && <>
                        <p className='mt-3'>Chú thích<br />
                            <b>* Nguyên tắc áp dụng: </b>Việc sắp xếp lịch làm việc chỉ áp dụng cho thời gian tương lai. Khi xác nhận áp dụng, các cấu hình đó sẽ được thay đổi theo cấu hình mới</p>
                    </>}
                </div>
                <div className="modal-footer" style={{ paddingTop: 20 }}>
                    <Button
                        onClick={closeModal}
                        className="ml-2 success-bland" color="success" type="button"
                    > Hủy bỏ</Button>
                    {dataLine && <Button
                        onClick={() => {
                            handleSubmit()
                        }}
                        className="ml-2" color="success" type="button"
                    > Xác nhận </Button>}
                </div>
                {loading && <Loader />}
            </PageContent>
        </CardBody>
    )
}

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

const PageContent = styled.div`
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`

const PageContentTable = styled.div`
    .react-bootstrap-table-pagination{
        padding: 0px 15px;
    }
`

export default connect(mapState)(AddSheet)